/*
 * THIS FILE WAS GENERATED BY "@atproto/lex". DO NOT EDIT.
 */

import { l } from '@atproto/lex'
import * as LabelDefs from '../../../com/atproto/label/defs.defs.js'
import * as ActorDefs from '../actor/defs.defs.js'
import * as RichtextFacet from '../richtext/facet.defs.js'
import * as FeedDefs from '../feed/defs.defs.js'

const $nsid = 'app.bsky.graph.defs'

export { $nsid }

type ListViewBasic = {
  $type?: 'app.bsky.graph.defs#listViewBasic'
  uri: l.AtUriString
  cid: l.CidString
  name: string
  purpose: ListPurpose
  avatar?: l.UriString
  listItemCount?: number
  labels?: LabelDefs.Label[]
  viewer?: ListViewerState
  indexedAt?: l.DatetimeString
}

export type { ListViewBasic }

const listViewBasic = l.typedObject<ListViewBasic>(
  $nsid,
  'listViewBasic',
  l.object({
    uri: l.string({ format: 'at-uri' }),
    cid: l.string({ format: 'cid' }),
    name: l.string({ maxLength: 64, minLength: 1 }),
    purpose: l.ref<ListPurpose>((() => listPurpose) as any),
    avatar: l.optional(l.string({ format: 'uri' })),
    listItemCount: l.optional(l.integer({ minimum: 0 })),
    labels: l.optional(
      l.array(l.ref<LabelDefs.Label>((() => LabelDefs.label) as any)),
    ),
    viewer: l.optional(l.ref<ListViewerState>((() => listViewerState) as any)),
    indexedAt: l.optional(l.string({ format: 'datetime' })),
  }),
)

export { listViewBasic }

type ListView = {
  $type?: 'app.bsky.graph.defs#listView'
  uri: l.AtUriString
  cid: l.CidString
  creator: ActorDefs.ProfileView
  name: string
  purpose: ListPurpose
  description?: string
  descriptionFacets?: RichtextFacet.Main[]
  avatar?: l.UriString
  listItemCount?: number
  labels?: LabelDefs.Label[]
  viewer?: ListViewerState
  indexedAt: l.DatetimeString
}

export type { ListView }

const listView = l.typedObject<ListView>(
  $nsid,
  'listView',
  l.object({
    uri: l.string({ format: 'at-uri' }),
    cid: l.string({ format: 'cid' }),
    creator: l.ref<ActorDefs.ProfileView>((() => ActorDefs.profileView) as any),
    name: l.string({ maxLength: 64, minLength: 1 }),
    purpose: l.ref<ListPurpose>((() => listPurpose) as any),
    description: l.optional(l.string({ maxGraphemes: 300, maxLength: 3000 })),
    descriptionFacets: l.optional(
      l.array(l.ref<RichtextFacet.Main>((() => RichtextFacet.main) as any)),
    ),
    avatar: l.optional(l.string({ format: 'uri' })),
    listItemCount: l.optional(l.integer({ minimum: 0 })),
    labels: l.optional(
      l.array(l.ref<LabelDefs.Label>((() => LabelDefs.label) as any)),
    ),
    viewer: l.optional(l.ref<ListViewerState>((() => listViewerState) as any)),
    indexedAt: l.string({ format: 'datetime' }),
  }),
)

export { listView }

type ListItemView = {
  $type?: 'app.bsky.graph.defs#listItemView'
  uri: l.AtUriString
  subject: ActorDefs.ProfileView
}

export type { ListItemView }

const listItemView = l.typedObject<ListItemView>(
  $nsid,
  'listItemView',
  l.object({
    uri: l.string({ format: 'at-uri' }),
    subject: l.ref<ActorDefs.ProfileView>((() => ActorDefs.profileView) as any),
  }),
)

export { listItemView }

type StarterPackView = {
  $type?: 'app.bsky.graph.defs#starterPackView'
  uri: l.AtUriString
  cid: l.CidString
  record: l.LexMap
  creator: ActorDefs.ProfileViewBasic
  list?: ListViewBasic
  listItemsSample?: ListItemView[]
  feeds?: FeedDefs.GeneratorView[]
  joinedWeekCount?: number
  joinedAllTimeCount?: number
  labels?: LabelDefs.Label[]
  indexedAt: l.DatetimeString
}

export type { StarterPackView }

const starterPackView = l.typedObject<StarterPackView>(
  $nsid,
  'starterPackView',
  l.object({
    uri: l.string({ format: 'at-uri' }),
    cid: l.string({ format: 'cid' }),
    record: l.lexMap(),
    creator: l.ref<ActorDefs.ProfileViewBasic>(
      (() => ActorDefs.profileViewBasic) as any,
    ),
    list: l.optional(l.ref<ListViewBasic>((() => listViewBasic) as any)),
    listItemsSample: l.optional(
      l.array(l.ref<ListItemView>((() => listItemView) as any), {
        maxLength: 12,
      }),
    ),
    feeds: l.optional(
      l.array(
        l.ref<FeedDefs.GeneratorView>((() => FeedDefs.generatorView) as any),
        { maxLength: 3 },
      ),
    ),
    joinedWeekCount: l.optional(l.integer({ minimum: 0 })),
    joinedAllTimeCount: l.optional(l.integer({ minimum: 0 })),
    labels: l.optional(
      l.array(l.ref<LabelDefs.Label>((() => LabelDefs.label) as any)),
    ),
    indexedAt: l.string({ format: 'datetime' }),
  }),
)

export { starterPackView }

type StarterPackViewBasic = {
  $type?: 'app.bsky.graph.defs#starterPackViewBasic'
  uri: l.AtUriString
  cid: l.CidString
  record: l.LexMap
  creator: ActorDefs.ProfileViewBasic
  listItemCount?: number
  joinedWeekCount?: number
  joinedAllTimeCount?: number
  labels?: LabelDefs.Label[]
  indexedAt: l.DatetimeString
}

export type { StarterPackViewBasic }

const starterPackViewBasic = l.typedObject<StarterPackViewBasic>(
  $nsid,
  'starterPackViewBasic',
  l.object({
    uri: l.string({ format: 'at-uri' }),
    cid: l.string({ format: 'cid' }),
    record: l.lexMap(),
    creator: l.ref<ActorDefs.ProfileViewBasic>(
      (() => ActorDefs.profileViewBasic) as any,
    ),
    listItemCount: l.optional(l.integer({ minimum: 0 })),
    joinedWeekCount: l.optional(l.integer({ minimum: 0 })),
    joinedAllTimeCount: l.optional(l.integer({ minimum: 0 })),
    labels: l.optional(
      l.array(l.ref<LabelDefs.Label>((() => LabelDefs.label) as any)),
    ),
    indexedAt: l.string({ format: 'datetime' }),
  }),
)

export { starterPackViewBasic }

type ListPurpose =
  | 'app.bsky.graph.defs#modlist'
  | 'app.bsky.graph.defs#curatelist'
  | 'app.bsky.graph.defs#referencelist'
  | l.UnknownString

export type { ListPurpose }

const listPurpose = l.string<{
  knownValues: [
    'app.bsky.graph.defs#modlist',
    'app.bsky.graph.defs#curatelist',
    'app.bsky.graph.defs#referencelist',
  ]
}>()

export { listPurpose }

/** A list of actors to apply an aggregate moderation action (mute/block) on. */
type Modlist = 'app.bsky.graph.defs#modlist'

export type { Modlist }

/** A list of actors to apply an aggregate moderation action (mute/block) on. */
const modlist = l.token($nsid, 'modlist')

export { modlist }

/** A list of actors used for curation purposes such as list feeds or interaction gating. */
type Curatelist = 'app.bsky.graph.defs#curatelist'

export type { Curatelist }

/** A list of actors used for curation purposes such as list feeds or interaction gating. */
const curatelist = l.token($nsid, 'curatelist')

export { curatelist }

/** A list of actors used for only for reference purposes such as within a starter pack. */
type Referencelist = 'app.bsky.graph.defs#referencelist'

export type { Referencelist }

/** A list of actors used for only for reference purposes such as within a starter pack. */
const referencelist = l.token($nsid, 'referencelist')

export { referencelist }

type ListViewerState = {
  $type?: 'app.bsky.graph.defs#listViewerState'
  muted?: boolean
  blocked?: l.AtUriString
}

export type { ListViewerState }

const listViewerState = l.typedObject<ListViewerState>(
  $nsid,
  'listViewerState',
  l.object({
    muted: l.optional(l.boolean()),
    blocked: l.optional(l.string({ format: 'at-uri' })),
  }),
)

export { listViewerState }

/** indicates that a handle or DID could not be resolved */
type NotFoundActor = {
  $type?: 'app.bsky.graph.defs#notFoundActor'
  actor: l.AtIdentifierString
  notFound: true
}

export type { NotFoundActor }

/** indicates that a handle or DID could not be resolved */
const notFoundActor = l.typedObject<NotFoundActor>(
  $nsid,
  'notFoundActor',
  l.object({
    actor: l.string({ format: 'at-identifier' }),
    notFound: l.literal(true),
  }),
)

export { notFoundActor }

/** lists the bi-directional graph relationships between one actor (not indicated in the object), and the target actors (the DID included in the object) */
type Relationship = {
  $type?: 'app.bsky.graph.defs#relationship'
  did: l.DidString

  /**
   * if the actor follows this DID, this is the AT-URI of the follow record
   */
  following?: l.AtUriString

  /**
   * if the actor is followed by this DID, contains the AT-URI of the follow record
   */
  followedBy?: l.AtUriString

  /**
   * if the actor blocks this DID, this is the AT-URI of the block record
   */
  blocking?: l.AtUriString

  /**
   * if the actor is blocked by this DID, contains the AT-URI of the block record
   */
  blockedBy?: l.AtUriString

  /**
   * if the actor blocks this DID via a block list, this is the AT-URI of the listblock record
   */
  blockingByList?: l.AtUriString

  /**
   * if the actor is blocked by this DID via a block list, contains the AT-URI of the listblock record
   */
  blockedByList?: l.AtUriString
}

export type { Relationship }

/** lists the bi-directional graph relationships between one actor (not indicated in the object), and the target actors (the DID included in the object) */
const relationship = l.typedObject<Relationship>(
  $nsid,
  'relationship',
  l.object({
    did: l.string({ format: 'did' }),
    following: l.optional(l.string({ format: 'at-uri' })),
    followedBy: l.optional(l.string({ format: 'at-uri' })),
    blocking: l.optional(l.string({ format: 'at-uri' })),
    blockedBy: l.optional(l.string({ format: 'at-uri' })),
    blockingByList: l.optional(l.string({ format: 'at-uri' })),
    blockedByList: l.optional(l.string({ format: 'at-uri' })),
  }),
)

export { relationship }
